import type { ArenaDefinition } from "@arena/shared";

/**
 * Grey-box test arena (GDD §6.1): a wide readable centre, a few solid
 * obstacles to test collisions and camera occlusion, two low platforms to
 * test jumping, open edges to test falling and respawn.
 */
export const GREYBOX_ARENA: ArenaDefinition = {
  id: "greybox",
  schemaVersion: 1,
  displayName: "Arena grigia",
  killY: -12,
  camera: { yaw: 0, pitch: 0.9, distance: 12.5 },
  solids: [
    { id: "floor", kind: "floor", min: { x: -16, y: -1, z: -11 }, max: { x: 16, y: 0, z: 11 } },

    { id: "pillar-ne", kind: "pillar", min: { x: 7.3, y: 0, z: 4.3 }, max: { x: 8.7, y: 3, z: 5.7 } },
    { id: "pillar-nw", kind: "pillar", min: { x: -8.7, y: 0, z: 4.3 }, max: { x: -7.3, y: 3, z: 5.7 } },
    { id: "pillar-se", kind: "pillar", min: { x: 7.3, y: 0, z: -5.7 }, max: { x: 8.7, y: 3, z: -4.3 } },
    { id: "pillar-sw", kind: "pillar", min: { x: -8.7, y: 0, z: -5.7 }, max: { x: -7.3, y: 3, z: -4.3 } },

    { id: "platform-n", kind: "platform", min: { x: -2.5, y: 0, z: 6 }, max: { x: 2.5, y: 1.2, z: 9 } },
    { id: "platform-s", kind: "platform", min: { x: -2.5, y: 0, z: -9 }, max: { x: 2.5, y: 1.2, z: -6 } },
  ],
  // Eight spawns on an ellipse around the centre, clear of every obstacle.
  spawnPoints: [
    { x: 0, y: 0, z: -3.5 },
    { x: 0, y: 0, z: 3.5 },
    { x: -6, y: 0, z: 0 },
    { x: 6, y: 0, z: 0 },
    { x: -4.5, y: 0, z: -2.5 },
    { x: 4.5, y: 0, z: 2.5 },
    { x: 4.5, y: 0, z: -2.5 },
    { x: -4.5, y: 0, z: 2.5 },
  ],
  // Team matches: Blue lines up on the south side, Red on the north, facing each other.
  teamSpawns: [
    [
      { x: -1.5, y: 0, z: -4.5 },
      { x: 1.5, y: 0, z: -4.5 },
      { x: -4.5, y: 0, z: -4.5 },
      { x: 4.5, y: 0, z: -4.5 },
    ],
    [
      { x: 1.5, y: 0, z: 4.5 },
      { x: -1.5, y: 0, z: 4.5 },
      { x: 4.5, y: 0, z: 4.5 },
      { x: -4.5, y: 0, z: 4.5 },
    ],
  ],
};
